export { FotogalerieModule } from './fotogalerie.module';
export { FotogalerieComponent } from './fotogalerie.component';

